export * from './applications';
export * from './connectors';
export * from './logs';
export * from './resources';
export * from './tenants';
export * from './page-tabs';
export * from './external-links';
export * from './storage';

export const requestTimeout = 20_000;
export const defaultPageSize = 20;

export enum searchKeys {
  signUp = 'sign_up',
}
